import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MultiMediaItemForm } from './multi-media-item.form';
import { TextboxComponent } from '../../../../../ui/src/lib/inputs/textbox/textbox.component';

@Component({
  selector: 'lc-multi-media-item-form',
  templateUrl: './multi-media-item-form.component.html',
  styleUrls: ['./multi-media-item-form.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TextboxComponent,
  ],
})
export class MultiMediaItemFormComponent {
  @Input()
    formGroup: MultiMediaItemForm;

  @Input()
    idPrefix: string = 'add';
}
